// extracted by mini-css-extract-plugin
export var select = "_ox-0";